import React from 'react';
import { StageUploadsAccordion } from './StageUploadsAccordion';
import { useQuery } from '@tanstack/react-query';
import { leadUploadService } from '../../../client_contact_stages/verve-design/services/leadUploadService';

export const InterestedDocumentsAccordion = ({ lead, onPreview }) => {
  const { data: uploadsData } = useQuery({
    queryKey: ['lead-uploads', lead?._id],
    queryFn: async () => {
      if (!lead?._id) return null;
      const res = await leadUploadService.getFilesByLead(lead._id);
      return res.data?.data?.files || res.data?.files || [];
    },
    enabled: !!lead?._id,
  });

  if (!lead) return null;

  const leadUploads = uploadsData || [];

  // Filter LeadUpload files matching "interested" status upload
  const uploadsFromService = leadUploads.filter(f => 
    f.type === 'interested' || 
    f.type === 'Interested Documents' || 
    f.type === 'Uploaded interested files' || 
    (!f.type && f.stage === 'interested')
  );

  // Check direct properties on lead object
  const uploadsFromLeadFiles = (lead.uploadedFiles || lead.files || []).filter(f => 
    f && (f.stage === 'interested' || f.type === 'interested')
  );

  const uploadsFromDesignMedia = (lead.designMedia || []).filter(f => 
    f && (f.stage === 'interested' || f.type === 'interested')
  );

  // Deduplicate files by fileId or _id
  const seenIds = new Set();
  const allFiles = [];

  [...uploadsFromService, ...uploadsFromDesignMedia, ...uploadsFromLeadFiles].forEach(file => {
    const id = file.fileId || file._id || file.url || file.filename || JSON.stringify(file);
    if (!seenIds.has(id)) {
      seenIds.add(id);
      allFiles.push({
        ...file,
        downloadPrefix: file.downloadPrefix || '/api/lead-uploads/stream'
      });
    }
  });

  return (
    <StageUploadsAccordion 
      title="Interested Documents" 
      files={allFiles} 
      colorTheme="cyan" 
      onPreview={onPreview} 
      downloadPrefix="/api/lead-uploads/stream" 
    />
  );
};
